import { Box, Typography } from "@mui/material";

interface Props {
  src: string;
  onClick: () => void;
}

export const LogoHeader = ({ src, onClick }: Props) => (
  <Box display="flex" flexDirection="column" alignItems="flex-end">
    <img
      style={{ cursor: 'pointer' }}
      onClick={onClick}
      src={src}
      width="100px"
      height="32px"
      alt="Logo"
    />
    <Typography variant="caption">corporativo</Typography>
  </Box>)
